<script setup lang="ts">
import type { InteractionEditorProps } from '../../../../model/assessments/interaction-editors.hook'

import { MARKER_INTERACTION_COPY } from '../../../../model/assessments/interaction-labels'
import { useInteractionFillInBlanks } from '../../../../model/assessments/interaction-editors.hook'
import AnnotatedTextarea from '../AnnotatedTextarea.vue'

defineOptions({
  name: 'InteractionFillInBlanks',
})

const props = defineProps<InteractionEditorProps>()

const copy = MARKER_INTERACTION_COPY.fill_in_blanks

const {
  refInlineText,
  setInlineText,
} = useInteractionFillInBlanks({
  screenId: () => props.screenId,
  activityId: () => props.activityId,
  interaction: () => props.interaction,
})
</script>

<template>
  <div class="interaction-fill-in-blanks">
    <!-- ONE field, and that is the whole point.
         The answer is written inside its own gap — `7 + {{five}} = {{twelve}}` — so there is no
         separate answer-key list, no gap numbering to keep track of and no reorder buttons: a gap
         and its answer are the same characters, and moving a gap moves its answer with it. The
         stored `{ text, blanks }` pair is derived from this string on every keystroke.

         What this replaced: a list of "Gap 1 / Gap 2" cards matched to `{{}}` markers by position
         alone, plus a gap counter and a mismatch warning that existed only to compensate for the
         author being unable to see which card belonged to which gap. -->
    <AnnotatedTextarea
      :label="copy.label"
      :value="refInlineText"
      :markers="['gap']"
      :placeholder="copy.placeholder"
      @update:value="setInlineText"
    />
  </div>
</template>

<style scoped lang="scss" src="./InteractionFillInBlanks.scss" />
